var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.757 26.1991C19.8025 26.1991 25.514 20.4876 25.514 13.4421C25.514 6.39656 19.8025 0.685059 12.757 0.685059C5.7115 0.685059 0 6.39656 0 13.4421C0 20.4876 5.7115 26.1991 12.757 26.1991Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.757 25.1991C19.2502 25.1991 24.514 19.9353 24.514 13.4421C24.514 6.94885 19.2502 1.68506 12.757 1.68506C6.26379 1.68506 1 6.94885 1 13.4421C1 19.9353 6.26379 25.1991 12.757 25.1991Z",
    stroke: "#BEC8CE",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkUnchecked);
export default __webpack_public_path__ + "static/media/checkmark_unchecked.31746500dae8fc537f00b6cae79652d7.svg";
export { ForwardRef as ReactComponent };